import React from 'react'
import { useState, useRouteAction, useSelector } from 'hooks'
import { connect, SVG, T, AvatarList } from 'components'

import { chat, like, wink } from 'store/actions'
import { history } from 'store'
import { getZodiac } from 'utils'

import chatIcon from 'assets/icons/icon_chat.svg'
import winkIcon from 'assets/icons/icon_wink.svg'
import hotIcon from 'assets/icons/icon_hot_bw.svg'
import hotCrossed from 'assets/icons/icon_hot_crossed_active.svg'
import friendAddIcon from 'assets/icons/icon_friend_add.svg'
import friendRemoveIcon from 'assets/icons/icon_friend_remove.svg'
import emailIcon from 'assets/icons/icon_email.svg'
import StyledInfoShort from './StyledInfoShort'

import { Block } from '../UserProfile'

const icons = {
  chat: chatIcon,
  wink: winkIcon,
  hot: hotIcon,
  sendMessage: emailIcon,
}

const friendIconSrc = (adult, isFriend, isHovered) => {
  if (adult) {
    return isFriend && isHovered ? hotCrossed : icons.hot
  }
  return isFriend ? friendRemoveIcon : friendAddIcon
}

const Action = ({ name, className, onClick }) => {
  const [isHovered, hover] = useState(false)
  const adult = useSelector(s => s.flags.adult)

  return (
    <div
      className={`icon icon-${name} ${className || ''}`}
      onClick={onClick}
      onMouseEnter={() => hover(1)}
      onMouseLeave={() => hover(0)}
    >
      <div className="icon__image">
        <SVG
          src={name.match(/hot|favorite/) ? friendIconSrc(adult, className == 'in-hotlist', isHovered) : icons[name]}
        />
      </div>
      <T as="div" className="icon__text" label={`actions/${name}`} />
    </div>
  )
}

const InfoShort = ({ user, registry, flags, className, chat, like, wink }) => {
  const { inHotlist, members, locationInfo } = user
  const { sexes, orientations, zodiacs, languages } = registry
  const spokenLanguages = (user.criteriaPerson1?.[8] || []).map(id => languages.find(e => e.id == id)?.name)
  const adult = useSelector(s => s.flags.adult)

  useRouteAction(user, { chat, like, wink })

  return (
    <StyledInfoShort className={className}>
      <div className="avatar half">
        <AvatarList user={user} />

        <div className="interaction-icons">
          <Action name="chat" onClick={() => chat(user)} />
          <Action name={adult ? 'hot' : 'favorite'} className={inHotlist && 'in-hotlist'} onClick={() => like(user)} />
          <Action name="wink" onClick={() => wink(user)} />
          {/* TODO: lead to /members/nickname/chat and make it work w/o previous messages */}
          {flags.mailbox && (
            <Action name="sendMessage" onClick={() => history.push(`/members/${user.nickname}/chat`)} />
          )}
        </div>
      </div>

      <div className="info half">
        <T as="div" className="group-title" label="iAm|noColon" />
        <Block name="sex" value={members && sexes.find(s => s.id === members[0].sexOfMemberId)?.name} />
        <Block name="age" value={members?.[0].age} />
        <Block name="orientation" value={members && orientations.find(o => o.id === members[0].orientationId)?.name} />
        <Block name="city" value={locationInfo?.city?.name} />
        <Block name="region" value={locationInfo?.region?.name} />
        <Block name="country" value={locationInfo?.country?.name} />
        <Block name="starSign" value={getZodiac(user, zodiacs)} />
        <div className="row">
          <T as="span" className="category" label="languages" />
          <span className="value">{spokenLanguages.join(', ')}</span>
        </div>
      </div>
    </StyledInfoShort>
  )
}

export default connect(({ registry, flags }) => ({ registry, flags }), { chat, like, wink })(InfoShort)
